import {SellerPJDataPayload} from "../shared/models/sellerPj.model";

export function mapFormToDataPersonalSellerPjOne(formValue: any): Partial<SellerPJDataPayload> {
  return {
    corporateName: formValue.corporateName,
    documentNumber: formValue.documentNumber,
    companyType: formValue.companyType,
    lastChangeDate: formValue.lastChangeDate,
    hasDeclaration: formValue.hasDeclaration,
    contact: {
      email: formValue.contact_email,
      phone: formValue.contact_phone,
    },
    address: {
      zipCode: formValue.address_zipCode,
      street: formValue.address_street,
      number: formValue.address_number,
      complement: formValue.address_complement,
      district: formValue.address_district,
      city: formValue.address_city,
      state: formValue.address_state,
    }
  }
}

export function mapFormToDataPersonalSellerPjTwo(formValue: any): Partial<SellerPJDataPayload> {
  const attorneys = (formValue.attorneys || []).map((attr: any, idx: number) => ({
    name: attr.name,
    documentNumber: attr.documentNumber,
    email: attr.email,
    phone: attr.phone,
    type: attr.type ?? attr[`type${idx}`],
  }));

  return {
    representatives: (formValue.representatives || []).map((rep: any, idx: number) => ({
      name: rep.name ?? formValue[`representatives_${idx}_name`],
      documentNumber: rep.documentNumber ?? formValue[`representatives_${idx}_documentNumber`],
    })),
    ...(isFilled(attorneys) ? {attorneys} : {}),
  }
}

export function mapFormToDataPersonalSellerPjThree(formValue: any): Partial<SellerPJDataPayload> {
  return {
    bankAccounts: (formValue.bankAccounts || []).map((acc: any) => ({
      name: acc.name,
      documentNumber: acc.documentNumber,
      bankNumber: acc.bankNumber,
      accountType: acc.accountType,
      agencyNumber: acc.agencyNumber,
      accountNumber: acc.accountNumber,
    })),
  }
}

function isFilled(valueForm: Partial<any>): boolean {
  return Object.values(valueForm).some(
    v => v !== undefined && v !== null && v.toString().trim() !== ''
  );
}
